export function Logo({ size = 44 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="Juwai Teer target logo">
      <circle cx="32" cy="32" r="30" fill="#ffffff" stroke="#5b2a86" strokeWidth="3" />
      <circle cx="32" cy="32" r="22" fill="none" stroke="#5b2a86" strokeWidth="3" />
      <circle cx="32" cy="32" r="14" fill="none" stroke="#5b2a86" strokeWidth="3" />
      <circle cx="32" cy="32" r="6" fill="#f97316" />
      <path d="M46 18 L58 6 M50 18 L58 10 L50 10" stroke="#f97316" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
